<template>
  <div
    class="chart-container"
    ref="chartContainer"
    @mouseleave="handleMouseout">
    <div
      class="echarts"
      ref="chart">

    </div>
  </div>

  <!-- <div
    class="chart-container"
    @mouseleave="handleMouseout">
    <chart
      :options="computedGraphOptions"
      :autoresize="true"
      ref="chartWrapperInstance"/>
  </div> -->
</template>

<style lang="scss">

.chart-container {
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  height: 100%;
}
.echarts {
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  height: 100%;
}

// Hacked up mobile styles...
@media (max-width: $breakpoint-desktop-min-width) {
  // .chart-container {
  //   max-width: 85vw;
  //   width: 85vw;
  // }
  // .echarts {
  //   max-width: 85vw;
  //   width: 85vw;
  // }
}
</style>

<script>


//
// TODO SCALE GRAPHS
//
// How to scale the graphs better...
//
// https://stackoverflow.com/questions/50078787/recharts-set-y-axis-range
//
import * as echarts from 'echarts';
import constants        from '@/constants';

import { generateMarkedAreasEchartsConfig, buildEchartsSeriesConfig } from '@/common/functions';

export default {
  name        : "LineGraph3",
  props       :
    [
      "series",
      "yAxes",
      "xAxisConfig",
      "size",
      "tooltip",
      "isLoading",
      "loadingIndicatorConfig",
      "noPadding",
      "isUsingDailyValues"
    ],

  //
  // Lifecycle Methods
  //

  /**
   * On mount
   * - deal with loading indicator
   */
  mounted() {

    // Initialize chart
    let chartDom = this.$refs.chart;
    this.chart = echarts.init(chartDom);

    // There's a watcher on the echarts config computed property that resets graph when things change
    this.setOptions();

    if (this.isLoading) {
      this.showLoadingIndicator();
    } else {
      this.hideLoadingIndicator();
      this.$nextTick(() => this.chart.resize());
    }

    this.resizeObserver = new ResizeObserver((entries) => {
      this.chart.resize();
    });
    this.resizeObserver.observe(this.$refs.chartContainer);
  },

  unmount() {
    this.resizeObserver.disconnect();
  },

  methods: {

    setOptions() {
      this.chart.setOption(this.computedGraphOptions);
    },

    /**
     *
     */
    resize() {
      if (this.chart) {
        this.chart.resize();
      }
    },

    /**
     * Let parent know that the user no longer has their mouse in the chart so that it can
     * hide things updated by the tooltip
     *
     * Workaround for API gap described here: https://github.com/apache/echarts/issues/11865
     */
    handleMouseout() {

      // Bump in the event loop to (hopefully?) prevent a race condition I sometimes see
      this.$nextTick(() => {
        this.$emit('echartsMouseout');
      })
    },

    // TODO MAJOR: this pattern sucks ass
    //
    // use builder pattern + .ts FFS
    getAxisDef(axisConfig) {

      let showAxisLine        = axisConfig && axisConfig.showAxis;
      let showAxisTicks       = axisConfig && axisConfig.showAxisTicks;
      let showAxisTickLabels  = axisConfig && axisConfig.showAxisTickLabels;
      let showAxisSplitLines  = axisConfig && axisConfig.showAxisSplitLines;
      let axisPointer         = axisConfig && axisConfig.axisPointer;
      let name                = axisConfig && axisConfig.name;

      let axisLineColor       = axisConfig && axisConfig.name;
      let splitLineType       = axisConfig && axisConfig.splitLineType;

      let definition =  {
        boundaryGap: [0, '100%'],
        name,
        nameLocation: 'middle',
        nameGap: 50,
        axisLine: {
            show: showAxisLine,
            lineStyle: {
              color: axisLineColor || 'rgba(0, 0, 0, .2)',
            },
        },
        axisTick: {
          lineStyle: {
              color: 'rgba(0, 0, 0, .9)',
          },
          show: showAxisTicks,
        },
        axisLabel : {
          show: showAxisTickLabels,
          textStyle : {
            color: 'rgba(0, 0, 0, .5)'
          }
        },
        splitLine   : {
          lineStyle: {
              color: 'rgba(0, 0, 0, .2)',
              type: splitLineType || 'solid',
          },
          show  : showAxisSplitLines
        },
        type  : "value",

      };

      if (axisPointer) {
        definition.axisPointer = axisPointer;
      }

      return definition;
    },

    showLoadingIndicator() {
      this.chart.showLoading('default', this.loadingIndicatorConfig);
    },

    hideLoadingIndicator() {
      this.chart.hideLoading();
    },

    updateTooltipValues(seriesData) {

      // But, throttle that shit...
      const THROTTLE_INTERVAL = 0;
      let previousCallTime = this.lastCallTime;
      this.lastCallTime = Date.now();

      if (previousCallTime === undefined
        || (this.lastCallTime - previousCallTime > THROTTLE_INTERVAL)) {

        const updates = seriesData.map(thing => {
          return {
            seriesId: thing.seriesId,
            value: thing.data[1],
          }
        })

        this.$emit('tooltipUpdated', updates);
      }
    }

  },

  computed: {

    computedGraphOptions() {

      let formattedSeries = [];
      if (this.series) {
        formattedSeries = this.series.map((s, index) => {

          const seriesConfig = buildEchartsSeriesConfig(s);

          let lastDataPoint = '';
          let lastDataPointArray = seriesConfig.data.slice(-1)[0];
          if (lastDataPointArray) {
            lastDataPoint = lastDataPointArray[1];
          }

          // Set initial variable values for snapshot / updating tooltip stuff
          this.$emit('setCurrentTooltipValue', {
            seriesId: s.id,
            value: lastDataPoint
          });

          return {
            data: seriesConfig.data,
            markArea: {
              itemStyle: {
                color: 'rgba(0, 0, 0, 0.1)',
              },
              data: seriesConfig.markArea.data,
              label: {
                color: '#000',
                fontSize: 14,
                show: false
              }
            },
            yAxisIndex      : index,
            name:             s.name,
            id              : s.id,
            type            : s.type || 'line',
            emphasis        : s.emphasis,
            itemStyle       : s.itemStyle,
            symbol          : s.symbol,
            symbolSize      : s.symbolSize,

            itemStyle       : s.itemStyle,
            // max             : s.max,
            showSymbol      : false,

            hoverAnimation  : false,
            animation       : false,

            lineStyle       : {
              color: s.lineColor || "#000",
              type: s.lineStyleType || "solid"
            }};
        });
      }

      let xAxis = null;

      if (this.xAxisConfig) {

        xAxis = this.getAxisDef(this.xAxisConfig);

        // TODO: x axis config goes here

        // 7 day:
        xAxis.splitNumber = 7;


        if (xAxis.showAxisTickLabels) {
          xAxis.axisLabel = {

            // Format the axis ticks with some data and time specific conventions
            formatter : (msSinceEpoch) => {
              // REFACTOR: hacks galore here
              const time = new Date(msSinceEpoch);
              const dayOfWeek = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(time);
              const showTime = !this.isUsingDailyValues && (time.toLocaleTimeString() !== '12:00:00 AM');

              return showTime ? `${time.toLocaleTimeString()}\n${dayOfWeek}\n${time.toLocaleDateString()}` : `${dayOfWeek}\n${time.toLocaleDateString()}`;
            },
            fontSize: 14,
            color: constants.COLORS.OSF_MEDIUM_GRAY
          }
        }

        xAxis.splitLine = {
          show: true,
          lineStyle: {
            type: 'dotted'
          }
        }

        // // 30 day:
        // xAxis.splitNumber = 4.5;

        // // 30 day:
        // xAxis.splitNumber = 14;

        // NOTE: this does something similar, but less good.
        // xAxis.interval = 86400000;
        // xAxis.axisTick.interval = 24;

      } else {
        xAxis = this.getAxisDef();
      }

      xAxis.type= "time";

      xAxis.axisPointer = {
        // value: '2016-10-7',
        show: true,
        snap: true,
        lineStyle: {
          color: constants.COLORS.OSF_LIGHT_GRAY,
          width: 2,
          type: 'dotted'
        },
        label: {
          formatter: (params) => {

            // IMPORTANT: THIS HAS INTENDED SIDE EFFECTS!
            //
            // And does some crazy shit... we're using `formatter(params)` as a hook
            // to show values selected by the tooltip elsewhere.
            this.updateTooltipValues(params.seriesData)

            // Now let's format that shit
            const time = new Date(params.value);

            // This is how you get "Monday" from a Date. TIL
            const dayOfWeek = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(time);

            return this.isUsingDailyValues ? `${dayOfWeek}, ${time.toLocaleDateString()}` : `${time.toLocaleTimeString()} on ${dayOfWeek}, ${time.toLocaleDateString()}`
          },
          backgroundColor: constants.COLORS.OSF_DARK_BLUE,
          fontSize: 14
        },
      };

      //
      // Make a y axis for each time series
      //
      //
      // TODO: historical average isn't working properly with 'max'...

      // Find the max value from discharge (regular & historical)

      let maxDischarge = 0;
      this.series.forEach((s) => {
        if (s.isDischargeTimeSeries && s.max > maxDischarge){
          maxDischarge = s.max;
        }
      });

      let yAxes = this.series.map((s) => {
        let yAxis   = this.getAxisDef(s.axisConfig);

        if (s.isDischargeTimeSeries) {
          yAxis.max = Math.ceil(maxDischarge * 1.1).toFixed(0);
        }
        else if (s.max) {
          yAxis.max = Math.ceil(s.max * 1.1).toFixed(0);
        }
        return yAxis;
      });

      const globalAxisPointer = {
        link: {
              xAxisIndex: 'all',
              // yAxisIndex: 'all'
            },
            show: 'auto',
            animation: false,
            animationDuringUpdate: 200,
            lineStyle: {
              color: '#B9BEC9',
              width: 1,
              type: 'dashed'
            },
            handle: {
              icon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z"
            },
            label: {
              show: true,
              precision: "auto",
              margin: 3,
              color: "#000",
              backgroundColor: "#fff",
              padding: {
                0: 5,
                1: 7,
                2: 5,
                3: 7
              },
              borderWidth: 0,
              borderRadius: 3
            }
          };

      // const paddingValue = '0%'; this.noPadding ? '0%' : '7%';
      const paddingValue = this.noPadding ? '0%' : '7%';

      return {
        title: null,
        aria: {
          show: true
        },
        xAxis: xAxis,
        yAxis: yAxes,
        series: formattedSeries,
        // axisPointer: globalAxisPointer,
        // axisPointer: tooltip,
        grid: {
          left: paddingValue,
          right: paddingValue,
          top: paddingValue,
          bottom: '5%',
          containLabel: true
        },
      }
    },
  },

  watch: {
    isLoading() {
      if (this.isLoading) {
        this.showLoadingIndicator();
      } else {
        this.hideLoadingIndicator();
      }
    },
    computedGraphOptions() {
      this.setOptions();
    }
  }
}

</script>
